<app-ion-page-container [isNeedBack]="true" [headerName]="'Страница сотрудника'">
  <app-ion-page-content [forceOverscroll]="false">
    <div class="employee-page">
      @if (!!userData) {
        @let employmentDate = userData.dateEmployment ?? userData.date;
        <div class="employee-page__avatar" [class.employee-page__avatar_border]="!userData.avatar">
          <app-image [img]="(userData.avatar?.previewLarge | addBaseUrl) ?? ''"></app-image>
          @if (currentUser$ | async; as currentUser) {
            @if (currentUser.id === userData.id) {
              <app-avatar-picker></app-avatar-picker>
            }
          }
        </div>
        <div class="employee-page__information">
          <div class="contacts">
            @if (employeeStatus) {
              <div class="contacts__status">
                <app-text
                  [text]="employeeStatus"
                  [textType]="TextType.base"
                  [textSize]="TextSizes.alert"
                ></app-text>
              </div>
            }
            <div class="contacts__name contacts__name_with-badge">
              @if (employmentDate | yearsOfServiceBadgeIcon; as badgeIcon) {
                <app-svg [icon]="badgeIcon" class="contacts__years_of_service_badge"></app-svg>
              }
              <app-text
                [canCopy]="isDesktop"
                [textType]="TextType.base"
                [textSize]="TextSizes.h1Header"
              >
                {{ employeeName }}
                @if (userData.isDirector) {
                  <img src="assets/images/icons-svg/director.svg" class="no-drag" />
                }
              </app-text>
            </div>
            @if (!!userData.userPosition?.name) {
              <div class="contacts__info">
                <app-text
                  text="Должность"
                  [textType]="TextType.base"
                  [textSize]="TextSizes.date"
                ></app-text>
                <app-text
                  [text]="userData.userPosition?.name"
                  [canCopy]="isDesktop"
                  [textSize]="TextSizes.h3Body"
                  [textType]="TextType.base"
                ></app-text>
              </div>
            }
            @if (!!departmentUrl) {
              <div class="contacts__info">
                <app-text
                  [text]="
                    userData.userDepartment.type === DepartmentsType.shop ? 'Магазин' : 'Отдел'
                  "
                  [textType]="TextType.base"
                  [textSize]="TextSizes.date"
                ></app-text>
                <div class="contacts__department">
                  <a [routerLink]="departmentUrl" (click)="clearScrollPositions()">
                    <app-text
                      [text]="userData.userDepartment.name"
                      [textType]="TextType.base"
                      [textSize]="TextSizes.h3Body"
                    >
                      @if (!!userData.userDepartment.city) {
                        <span class="contacts__divider"></span>
                      }
                    </app-text>
                    @if (!!userData.userDepartment.city) {
                      <app-text
                        [text]="userData.userDepartment.city.name"
                        [textType]="TextType.base"
                        [textSize]="TextSizes.h3Body"
                      ></app-text>
                    }
                  </a>
                </div>
              </div>
            }
            <div class="contacts__contact-block">
              @if (userData.email) {
                <div class="contacts__data">
                  <a class="contacts__text" [href]="'mailto: ' + userData.email" #userEmail>
                    <app-svg icon="email"></app-svg>
                    <app-text
                      [text]="userData.email"
                      [textType]="TextType.base"
                      [textSize]="TextSizes.h5Post"
                    ></app-text>
                  </a>
                </div>
              }
              @if (userData.dateOfBirth | birthdayFormat; as birthdayText) {
                <div class="contacts__info contacts__info_birthday">
                  <app-svg icon="birthday"></app-svg>
                  <app-text
                    [text]="birthdayText"
                    [textType]="TextType.base"
                    [textSize]="TextSizes.h5Post"
                  ></app-text>
                </div>
              }
              @if (employmentDate | yearsOfService; as yearsOfServiceText) {
                <div class="contacts__info contacts__info_years_of_service">
                  <app-svg icon="years-of-service"></app-svg>
                  <app-text
                    [text]="yearsOfServiceText"
                    [textType]="TextType.base"
                    [textSize]="TextSizes.h5Post"
                  ></app-text>
                </div>
              }
            </div>
          </div>

          @if (showAboutSection) {
            <div class="employee-page__about">
              <div class="employee-page__about-head">
                <app-text
                  text="Обо мне"
                  [textType]="TextType.base"
                  [textSize]="TextSizes.date"
                ></app-text>
                @if (isOwnProfile) {
                  <button
                    type="button"
                    class="employee-page__about-edit"
                    [class.employee-page__about-edit_hidden]="isEditingAbout"
                    aria-label="Редактировать раздел «Обо мне»"
                    [attr.aria-hidden]="isEditingAbout ? 'true' : null"
                    [attr.tabindex]="isEditingAbout ? -1 : null"
                    (click)="startEditAbout()"
                  >
                    <img src="assets/images/icons-svg/edit.svg" alt="" />
                  </button>
                }
              </div>

              @if (!isEditingAbout && aboutDisplayText.trim()) {
                <div class="employee-page__about-text">
                  <app-text
                    [text]="aboutDisplayText"
                    [textType]="TextType.base"
                    [textSize]="TextSizes.h3Body"
                  ></app-text>
                </div>
              }

              @if (isEditingAbout) {
                <div class="employee-page__about-edit-mode">
                  <div #aboutEditRow class="employee-page__about-edit-row">
                    <div class="employee-page__about-field-col">
                      <textarea
                        #aboutTextarea
                        class="employee-page__about-field"
                        [(ngModel)]="aboutDraft"
                        [attr.maxlength]="maxAboutLength"
                        placeholder="до 500 символов"
                        autocomplete="off"
                      ></textarea>
                      @if (aboutDraft.trim().length > 0) {
                        <span class="employee-page__about-counter"
                          >{{ aboutDraft.length }}/{{ maxAboutLength }}</span
                        >
                      }
                    </div>
                    <button
                      type="button"
                      class="employee-page__about-done"
                      [disabled]="isSavingAbout"
                      (click)="saveAbout()"
                    >
                      @if (isSavingAbout) {
                        <app-spinner [isLoading]="true" [color]="SpinnerColor.light"></app-spinner>
                      }
                      @if (!isSavingAbout) {
                        <span class="employee-page__about-done-label">готово</span>
                      }
                    </button>
                  </div>
                </div>
              }
            </div>
          }

          <!-- @if (canReport) {
            <div class="employee-page__report">
              <app-button
                (click)="blockUser()"
                [text]="'Заблокировать'"
                [btnType]="'btn-filter'"
                [textSize]="'btn-filter'"
                [isLoading]="isLoading"
              ></app-button>
            </div>
          } -->
        </div>
      }
    </div>
    <ng-content></ng-content>
  </app-ion-page-content>
</app-ion-page-container>
